/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbPayorSourceSummary
 */
export interface HchbPayorSourceSummary {
    /**
     * 
     * @type {string}
     * @memberof HchbPayorSourceSummary
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPayorSourceSummary
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPayorSourceSummary
     */
    service_line_type?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HchbPayorSourceSummary
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HchbPayorSourceSummary
     */
    use_physician_medicaid_no: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HchbPayorSourceSummary
     */
    frequently_used: boolean;
    /**
     * 
     * @type {string}
     * @memberof HchbPayorSourceSummary
     */
    claim_type?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPayorSourceSummary
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPayorSourceSummary
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPayorSourceSummary
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPayorSourceSummary
     */
    zip?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPayorSourceSummary
     */
    phone?: string;
}

/**
 * Check if a given object implements the HchbPayorSourceSummary interface.
 */
export function instanceOfHchbPayorSourceSummary(value: object): value is HchbPayorSourceSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('use_physician_medicaid_no' in value) || value['use_physician_medicaid_no'] === undefined) return false;
    if (!('frequently_used' in value) || value['frequently_used'] === undefined) return false;
    return true;
}

export function HchbPayorSourceSummaryFromJSON(json: any): HchbPayorSourceSummary {
    return HchbPayorSourceSummaryFromJSONTyped(json, false);
}

export function HchbPayorSourceSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPayorSourceSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'service_line_type': json['service_line_type'] == null ? undefined : json['service_line_type'],
        'active': json['active'],
        'use_physician_medicaid_no': json['use_physician_medicaid_no'],
        'frequently_used': json['frequently_used'],
        'claim_type': json['claim_type'] == null ? undefined : json['claim_type'],
        'street': json['street'] == null ? undefined : json['street'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'phone': json['phone'] == null ? undefined : json['phone'],
    };
}

export function HchbPayorSourceSummaryToJSON(json: any): HchbPayorSourceSummary {
    return HchbPayorSourceSummaryToJSONTyped(json, false);
}

export function HchbPayorSourceSummaryToJSONTyped(value?: HchbPayorSourceSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'service_line_type': value['service_line_type'],
        'active': value['active'],
        'use_physician_medicaid_no': value['use_physician_medicaid_no'],
        'frequently_used': value['frequently_used'],
        'claim_type': value['claim_type'],
        'street': value['street'],
        'city': value['city'],
        'state': value['state'],
        'zip': value['zip'],
        'phone': value['phone'],
    };
}

